import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'

import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/700.css'
import '@fontsource/material-icons'
import './assets/css/material-icons-usage.css'
createApp(App).use(store).use(router).use(VueSweetalert2).mount('#app')
